<!-- PR/PO信息 -->
<div class="main">
  <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'PRPOInfo.PRPOInfo' | translate }}</h4>
  <div class="body">
    <nz-list nzBordered>
      <nz-list-item>
        <nz-table #basicTable nzSize="small" [nzData]="listOfData" [nzShowPagination]="false">
          <thead>
            <tr>
              <th *ngFor="let option of listOption" scope="col">{{ option.text | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of basicTable.data">
              <!-- 类别/项目 -->
              <td>{{ item.itemdesc }}</td>
              <!-- PR单号 -->
              <td>{{ item.purno }}</td>
              <!-- PRL -->
              <td>{{ item.itemno }}</td>
              <!-- PO单号 -->
              <td>{{ item.pono }}</td>
              <!-- POL -->
              <td>{{ item.poln }}</td>
              <!-- 厂商 -->
              <td>{{ item.outsource }}</td>
              <!-- Buyer -->
              <td>{{ item.cusr }}</td>
              <!-- 费用 -->
              <td>{{ item.amnt }}</td>
              <!-- 交期 -->
              <td>{{ item.ddat }}</td>
              <!-- PO附件 -->
              <td *ngIf="item.poAttachment !== undefined && item.poAttachment !== null">
                <a nz-button [nzSize]="small" nzType="link" href="{{ item.poAttachment }}" target="blank">
                  <em nz-icon nzType="file-image" nzTheme="twotone"></em>
                </a>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </nz-list-item>
    </nz-list>
  </div>
</div>